// extracted by mini-css-extract-plugin
export default {"frCont":"MainFormTemplate_frCont__tFsgX","xClose":"MainFormTemplate_xClose__0L8E1"};